module.exports = __webpack_public_path__ + "img/f1.4a34b131.png";